import React from "react";
import "../App.css";
import { Button } from "./Button/Button";
import "./Hero.css";

function Hero() {
    return (
        <>
            <div className="hero-container">
                <p>Unique and Custom Yard Designs</p>
                <h1>Creating Your Ideas In 3D</h1>

                <div className="hero-btns">
                    <Button
                        className="btns"
                        buttonStyle="btn--outline"
                        buttonSize="btn--large"
                        buttonLink="/contact"
                    >
                        INQUIRE
                    </Button>
                </div>
            </div>
        </>
    );
}

export default Hero;
